/**
 * Format money amount based on language
 * FR (CAD): 10 000,00 $ (or 10 000 $ with decimals=0)
 * EN (USD): $ 10 000,00 (or $ 10 000 with decimals=0)
 */
export const formatMoney = (amount, language = 'fr', decimals = 2) => {
  const num = Number(amount) || 0;
  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);
  
  if (language === 'fr') {
    const intPart = Math.round(decimals === 0 ? abs : Math.floor(abs)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (decimals === 0) return `${sign}${intPart} $`;
    const dec = abs.toFixed(2).split('.')[1];
    return `${sign}${Math.floor(abs).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${dec} $`;
  }
  
  const intPart = Math.round(decimals === 0 ? abs : Math.floor(abs)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  if (decimals === 0) return `${sign}$ ${intPart}`;
  const dec = abs.toFixed(2).split('.')[1];
  return `${sign}$ ${Math.floor(abs).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${dec}`;
};
